export default {"src":"/_next/static/media/return-arrow.2048e808.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};